module.exports = __webpack_public_path__ + "static/media/approved-banner.e5ac7ebc.svg";